import { create } from 'zustand';
import * as api from '../api/client';

const useAppStore = create((set, get) => ({
  // Session
  sessionId: null,
  setSessionId: (id) => set({ sessionId: id }),

  // Chat
  messages: [],
  addMessage: (msg) => set(state => ({ messages: [...state.messages, msg] })),
  appendToken: (token) => set(state => {
    const msgs = [...state.messages];
    const last = msgs[msgs.length - 1];
    if (last && last.role === 'assistant') {
      msgs[msgs.length - 1] = { ...last, content: last.content + token };
    }
    return { messages: msgs };
  }),
  updateLastMessage: (patch) => set(state => {
    const msgs = [...state.messages];
    const last = msgs[msgs.length - 1];
    if (last && last.role === 'assistant') {
      const resolved = typeof patch === 'function' ? patch(last) : patch;
      msgs[msgs.length - 1] = { ...last, ...resolved };
    }
    return { messages: msgs };
  }),
  clearMessages: () => set({ messages: [] }),

  // Knowledge graph
  atoms: [],
  atomStats: { total_atoms: 0, by_domain: {}, by_type: {} },
  loadAtoms: async (domain = null) => {
    const data = await api.getAtoms(domain, 500);
    set({ atoms: data.atoms, atomStats: { total_atoms: data.total } });
  },
  loadStats: async () => {
    const data = await api.getStatus();
    set({ atomStats: data });
  },

  // Goals
  goals: [],
  loadGoals: async () => {
    const data = await api.getGoals();
    set({ goals: data.goals });
  },

  // Insights
  insights: [],
  loadInsights: async () => {
    const data = await api.getInsights();
    set({ insights: data.insights });
  },
  dismissInsight: async (eventId) => {
    await api.acknowledgeInsight(eventId);
    set(state => ({
      insights: state.insights.filter(i => i.name !== eventId)
    }));
  },

  // System status
  systemStatus: null,
  loadSystemStatus: async () => {
    const data = await api.getStatus();
    set({ systemStatus: data, atomStats: data });
  },

  // LLM configuration
  llmConfig: null,
  llmSaving: false,
  loadLLMConfig: async () => {
    const data = await api.getLLMConfig();
    set({ llmConfig: data });
  },
  updateLLMConfig: async (provider, enabled) => {
    set({ llmSaving: true });
    try {
      const data = await api.setLLMConfig(provider, enabled);
      // Reload full config to get updated online status
      const full = await api.getLLMConfig();
      set({ llmConfig: full });
      return data;
    } finally {
      set({ llmSaving: false });
    }
  },

  // UI state
  activeTab: 'chat',
  setActiveTab: (tab) => set({ activeTab: tab }),
  selectedAtom: null,
  setSelectedAtom: (atom) => set({ selectedAtom: atom }),
  lastReasoningChain: null,
  setLastReasoningChain: (chain) => set({ lastReasoningChain: chain }),
}));

export default useAppStore;
